import React from 'react';
import { Card } from 'react-bootstrap';
import { constants } from 'src/utils/const';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { redirectPartyList } from 'src/store/commonlist/actions';

interface RowData {
  id: number;
  sender_id: number;
  receiver_id: number;
  amount: number;
  remarks: string;
  date: string;
  credit?: number;
  debit?: number;
  created_at?: string;
  [key: string]: any;
}

interface BalanceComponentProps {
  selectedRows: RowData[];
  senderId: any;
  prevSender: any;
  setPrevSender: React.Dispatch<React.SetStateAction<any>>;
  isCheckboxChecked: boolean;
  apiTotals: {
    total_Credit: number;
    total_Debit: number;
    total_Balance: number;
  };
}
const BalanceComponent: React.FC<BalanceComponentProps> = ({ senderId, selectedRows,prevSender, setPrevSender, isCheckboxChecked, apiTotals}) => {
  // const [prevSender,setPrevSender] = useState(null)
  const redirectList = useSelector((state: any) => state.commonList.redirectList);
// console.log(redirectList,"this is id from reduxcx");

  // console.log("sender idddddddddddddddddd",senderId);

  if (selectedRows.length === 0 && !isCheckboxChecked) {
    return null;
  }
  // Calculate total debit and credit with correct handling of negative values
  let totalDebitValue = selectedRows.reduce((sum, row) => {
    return row.created_at ? sum + (row.debit ?? 0) : sum;
  }, 0);
  let totalCreditValue = selectedRows.reduce((sum, row) => {
    return row.created_at ? sum + (row.credit ?? 0) : sum;
  }, 0);
  let totalBalanceValue = totalCreditValue + totalDebitValue;

  let totalDebit = constants.formatAmount(totalDebitValue);
  let totalCredit = constants.formatAmount(totalCreditValue);
  let totalBalance = constants.formatAmount(totalBalanceValue);

  if (isCheckboxChecked && selectedRows.length === 0) {
    totalDebit = constants.formatAmount(apiTotals.total_Debit);
    totalCredit = constants.formatAmount(apiTotals.total_Credit);
    totalBalance = constants.formatAmount(apiTotals.total_Balance);
  }

  if(senderId !== prevSender){
    setPrevSender(senderId)
    // console.log("chnageddddddddd");
    // console.log(totalCredit,"total credited");
    
    totalDebit = 0
    totalCredit = 0
    totalBalance = 0
  }
  return (
    <Card>
      <Card.Header className='p-4'>
        <Card.Title>Balance</Card.Title>
      </Card.Header>
      <Card.Body className='p-4'>
        <div className='d-flex justify-content-between'>
          <h3 className='fs-8'>Total Debit</h3>
          <p>{totalDebit}</p>
        </div>
        <div className='d-flex justify-content-between'>
          <h3 className='fs-8'>Total Credit</h3>
          <p>{totalCredit}</p>
        </div>
        <div className='d-flex justify-content-between'>
          <h3 className='fs-8'>Total Balance</h3>
          <p>{totalBalance}</p>
        </div>
      </Card.Body>
    </Card>
  );
};

export default BalanceComponent;
